import { createAction } from '@reduxjs/toolkit'
export const resetProduct = createAction('resetProduct')
